import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Header } from '@/components/layout/header';
import { AppSidebar } from '@/components/sidebar';
import { SidebarInset } from '@/components/ui/sidebar';
import { authClient } from '@/lib/auth-client';

export const Route = createFileRoute('/_authenticated/_projects')({
  component: ProjectsLayout,
  beforeLoad: async ({ context }) => {
    if (context.activeOrganizationId) {
      return {};
    }

    const { data: organizations } = await authClient.organization.list();

    if (!organizations || organizations.length === 0) {
      return redirect({ to: '/organization/create' });
    }

    await authClient.organization.setActive({ organizationId: organizations[0].id });
    context.setOrganizationId(organizations[0].id);
  },
});

function ProjectsLayout() {
  return (
    <>
      <AppSidebar layout="projects" />
      <SidebarInset>
        <Header layout="projects" />
        <div className="flex flex-1 flex-col px-4 gap-4">
          <Outlet />
        </div>
      </SidebarInset>
    </>
  );
}
